// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__Efqdh","filters_close":"FiltersBlock_filters_close__ZhVuT"};